/* eslint-disable import/prefer-default-export */
import * as Ladda from 'ladda';


export class RegisterForm {
    constructor(options) {
        $('.form_signin').on('submit', function RegisterFormSubmit(e) {
            e.preventDefault();

            const l = Ladda.create($('.form_signin button[type=submit]')[0]);
            l.start();

            const postData = $(this).serialize();
            $.post(`${options.controller_url}do-register`, postData, (data) => {
                if (data) {
                    if (data.msg) {
                        $('.form-group').addClass('has-error');
                        $('#errors').removeClass('hidden').find('label').html(data.msg.text);
                        return;
                    }

                    if (data.url) {
                        window.location.href = data.url;
                    }
                }
            })
                .always(() => {
                    l.stop();
                });
        });
    }
}
